import React, { useState, useEffect } from 'react'
import './style.scss'

import { ButtonNew } from './../../components/Form'
import { mensagemErro, Icon } from './../../components/Layout'
import api from './../../api'

import { useLayout } from './../../context/Layout'
import { useAuth } from './../../context/Auth'

function SelecionarAvatar() {

    const { setLoadFull, loadFull } = useLayout()
    const { getUser, setUser } = useAuth()

    const [data, setData] = useState([])
    const [imageSelected, setImageSelected] = useState('')
    const [imageAvatar, setImageAvatar] = useState('')

    useEffect(() => {
        onBuscaDados()
    }, [])

    async function onBuscaDados() {

        setLoadFull(true)

        const resp = await api.get('avatars')

        if (resp.data?.erro) {
            setLoadFull(false)
            mensagemErro(`${resp.data.erro.message}`)

            return
        }

        setData(resp.data)
        setLoadFull(false)
    }

    function onSelected(item) {

        setImageSelected(item.name)
        setImageAvatar(item.image)
    }

    async function onSelecionar() {

        setLoadFull(true)

        const usuario = getUser()

        const resp = await api.post('avatars/save', {
            avatar: imageSelected
        })

        if (resp.data?.erro) {
            setLoadFull(false)
            mensagemErro(`${resp.data.erro.message}`)

            return
        }

        const _user = getUser()
        setUser({
            ..._user,
            ...{ avatar: imageAvatar }
        })

        window.location.reload();
    }

    return (
        <>
            {
                !loadFull &&
                !loadFull &&
                <div className="selAvatarFull">
                    <div className="auth-card">
                        <div className="card-body">
                            <div className="auth-header">
                                <h2>Escolha seu Avatar</h2>
                                <p>Personalize sua experiência selecionando uma imagem que represente você.</p>
                            </div>

                            <div className="avatars-grid">
                                {data.map((item, index) => (
                                    <div
                                        key={index}
                                        className={`avatar-item ${imageSelected === item.name ? 'selected' : ''}`}
                                        onClick={() => onSelected(item)}
                                    >
                                        <img
                                            src={item.image}
                                            alt={item.name}
                                        />
                                        {imageSelected === item.name && <div className="indicator" />}
                                    </div>
                                ))}
                            </div>

                            <div className="action-area">
                                <ButtonNew
                                    name='Confirmar escolha'
                                    icon={<Icon name="ti-check" />}
                                    onClick={onSelecionar}
                                    className="btn-primary"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default SelecionarAvatar